import { css } from 'styled-components';
import { breakpoint, pxToRem } from '@fil-react-mixins/styled';
import { gridContainerPaddingStyles } from './GridContainer.constants';
export default css `
  max-width: ${(props) => pxToRem(parseInt(props.theme.size.grid['max-width'].value, 10))};
  margin: 0 auto;
  ${gridContainerPaddingStyles}
  ${({ variation }) => variation === 'fluid' &&
    css `
      max-width: 100%;
    `}

  ${({ variation }) => variation === 'full' &&
    css `
      max-width: 100%;
      padding-left: 0;
      padding-right: 0;
      ${breakpoint('md', css `
          padding-left: 0;
          padding-right: 0;
        `)}
    `}
`;
